/*
 *
 * TurnReportListItem
 *
 */

import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import Link from '@mui/material/Link';
import ListItemText from '@mui/material/ListItemText';
import { red } from '@mui/material/colors';
import PublisherCard from '~/components/PublisherCard';
import Tag from '~/components/Tag';
import { TurnDto } from '~/generated';
import ListItemButton from '@mui/material/ListItemButton';
import messages from './messages';
import styles from './styles.module.css';

const REPORTING_LIMIT_IN_DAYS = 7;

type TurnReportListItem = {
  showCompletedState: boolean;
  onClick?: () => void;
  isClosed: boolean;
  turn: TurnDto;
  turnLead?: {
    id: number;
    firstName: string;
    middleName?: string;
    lastName: string;
    email: string;
    phone: string;
    languages: string[];
  };
};

const TurnReportListItem = (props: TurnReportListItem) => {
  const getPublisherName = (publisher: {
    firstName: string;
    middleName?: string;
    lastName: string;
  }) =>
    [publisher.firstName, publisher.middleName, publisher.lastName].join(' ');

  const createReportTitle = () => {
    const { route, shift } = props.turn;
    if (!shift || !route) {
      throw new Error('invalid turn');
    }
    const { startDate, endDate } = shift;
    const date = `${moment(startDate).format('LLL')} - ${moment(endDate).format(
      'LT'
    )}`;
    return (
      <span>
        {route.name} {date}
      </span>
    );
  };

  const calculateTimeDifference = () =>
    moment().diff(moment(props.turn.shift?.startDate), 'days');
  const timeDifference = calculateTimeDifference();
  const isUrgent =
    !props.isClosed && timeDifference > REPORTING_LIMIT_IN_DAYS - 2;
  return (
    <ListItemButton onClick={props.onClick} disabled={!props.onClick}>
      <ListItemText
        primary={createReportTitle()}
        secondary={
          <span>
            <span className={styles['time-difference-label']}>
              <FormattedMessage
                {...messages.daysAgo}
                values={{
                  days: timeDifference,
                }}
              />
            </span>
            {props.turnLead && (
              <>
                <span>·</span>
                <PublisherCard
                  key={`publisher-card-${props.turnLead.id}`}
                  publisher={props.turnLead}
                >
                  {(args) => (
                    <Link
                      component="button"
                      onClick={(evt) => {
                        evt.stopPropagation();
                        args.onClick(evt);
                      }}
                      variant="body2"
                      underline="hover"
                    >
                      {}
                      {getPublisherName(props.turnLead!)}
                    </Link>
                  )}
                </PublisherCard>
              </>
            )}
          </span>
        }
      />
      {isUrgent && (
        <Tag
          style={{
            backgroundColor: red[100],
            color: red[900],
          }}
        >
          <FormattedMessage {...messages.urgent} />
        </Tag>
      )}
    </ListItemButton>
  );
};

export default TurnReportListItem;
